import ExcelJS from 'exceljs';

export default class ReporteCxcExporter {
  static generateWorkbook(dataProcessed) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Reporte');

    // Definir los encabezados principales
    const headers = ['Fecha', 'Descripción', 'Cant', 'Monto'];
    const headerRow = worksheet.addRow(headers);
    headerRow.font = { bold: true, size: 12 };
    headerRow.alignment = { horizontal: 'center', vertical: 'middle' };
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFADD8E6' } // Light Blue
      };
      cell.border = { top: { style: 'thin' }, bottom: { style: 'thin' } };
    });

    // Recorrer los datos procesados
    dataProcessed.forEach((item) => {
      if (item.header) {
        // Fila de encabezado de sección
        const headerCell = worksheet.addRow([item.text]);
        worksheet.mergeCells(`A${headerCell.number}:D${headerCell.number}`);
        headerCell.getCell(1).font = { bold: true, size: 12 };
        headerCell.getCell(1).alignment = { horizontal: 'center' };
        headerCell.getCell(1).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFDDDDDD' } // Gris claro
        };
      } else if (item.footer) {
        // Fila de pie de sección con total
        const footerRow = worksheet.addRow([
          '',
          item.text,
          '',
          item.total,
        ]);
        footerRow.getCell(2).font = { bold: true };
        footerRow.getCell(4).font = { bold: true };
        footerRow.getCell(2).alignment = { horizontal: 'right' };
        footerRow.getCell(4).alignment = { horizontal: 'right' };
        footerRow.eachCell((cell) => {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFDDDDDD' } // Gris claro
          };
        });
      } else {
        // Fila normal con datos
        worksheet.addRow([
          item.fecha,
          item.Nombre,
          item.Cnt,
          item.Cnt * item.Pco.C,
        ]);
      }
    });

    // Autoajuste de ancho de columnas
    worksheet.columns.forEach((column) => {
      let maxLength = column.width || 10;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const text = cell.value ? cell.value.toString() : '';
        maxLength = Math.max(maxLength, text.length);
      });
      column.width = maxLength + 2; // Padding extra
    });

    return workbook;
  }

  static async generateExcelBuffer(dataProcessed) {
    const workbook = ReporteCxcExporter.generateWorkbook(dataProcessed);
    return await workbook.xlsx.writeBuffer();
  }
}
